(function (ng) {
    var _offsetVertical = {},
        _offsetHorizontal = {};

    // Allow multiple elements to synchronize their scroll position.  Useful for floated headers :)
    ng.module('evo.Compare.Directives').directive('syncScroll', function () {
        return {
            restrict: 'A',
            scope: {
                key: '@syncScroll',
                direction: '@'
            },
            link: function (scope, $el) {
                // Scroll element horizontally and store new scroll position, or update current scroll position
                function scrollHorizontal(thisElementScrolling) {
                    var scroll = $el.scrollLeft(),
                        storedScroll = _offsetHorizontal[scope.key] || 0;

                    if (scroll == storedScroll)
                        return;

                    if (thisElementScrolling) {
                        _offsetHorizontal[scope.key] = scroll;
                        scope.$apply();
                    }
                    else {
                        $el.scrollLeft(storedScroll);
                    }
                };

                // Scroll element vertically and store new scroll position, or update current scroll position
                function scrollVertical(thisElementScrolling) {
                    var scroll = $el.scrollTop(),
                        storedScroll = _offsetVertical[scope.key] || 0;

                    if (scroll == storedScroll)
                        return;

                    if (thisElementScrolling) {
                        _offsetVertical[scope.key] = scroll;
                    }
                    else {
                        $el.scrollTop(storedScroll);
                    }
                };

                // Watch for scroll events and update stored scroll position
                ng.element($el).bind('scroll', function () {
                    if (scope.direction == 'horizontal' || scope.direction == 'both') {
                        scrollHorizontal(true);
                    }

                    if (scope.direction == 'vertical' || scope.direction == 'both') {
                        scrollVertical(true);
                    }
                    scope.$apply();
                });

                // Watch for changes in the stored scoll position and scroll the element to match
                scope.$watch(function () { return scope.direction == 'horizontal' ? _offsetHorizontal[scope.key] : _offsetVertical[scope.key] }, function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        if (scope.direction == 'horizontal') {
                            scrollHorizontal(false);
                        }
                        else {
                            scrollVertical(false);
                        }
                    }
                });
            }
        }
    });
})(angular);